// extracted by mini-css-extract-plugin
export default {"mCard":"HB-z","image":"IB-z","imageNoBackground":"JB-z","imageHasCategory":"KB-z","fullWidth":"LB-z"};